import { render } from "./TVPDisparities.vue?vue&type=template&id=2f47edf5"
import script from "./TVPDisparities.vue?vue&type=script&lang=js"
export * from "./TVPDisparities.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__